import { useTheme } from "../styles/theme";
import { useApp } from "../context/AppContext";
import { useNavigate, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { label: "Dashboard", icon: "📊 ", path: "/dashboard" },
  { label: "Daily P&L", icon: "📅 ", path: "/daily-pl" },
  { label: "Purchases", icon: "🏪 ", path: "/purchases" },
  { label: "Expenses", icon: "💸 ", path: "/expenses" },
  { label: "Sales", icon: "💰 ", path: "/sales" },
  { label: "Salaries", icon: "👤 ", path: "/salaries" },
  { label: "Debt Manager", icon: "🔴 ", path: "/debt-manager" },
  { label: "Ledger", icon: "📒 ", path: "/ledger" },
  { label: "Settings", icon: "⚙️ ", path: "/settings" },
];

export default function Nav() {
  const S = useTheme();
  const { debts, totalDebt } = useApp();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav style={S.nav}>
      {NAV_ITEMS.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            style={{ ...S.navBtn, ...(isActive ? S.navActive : {}) }}
          >
            {item.icon}
            {item.label}
            {item.label === "Debt Manager" && totalDebt > 0 && (
              <span style={S.navBadge}>
                {debts.filter((d) => d.remaining > 0).length}
              </span>
            )}
          </button>
        );
      })}
    </nav>
  );
}
